export default {
  methods: {
    // 删除SPU
    handleDelSku(skuId) {
      this.$confirm((<div class="jsx-content">
        确定删除SKU？
        <div style="color: #E63946; margin-top: 5px;">
          注意：删除后，无法恢复数据！
        </div>
      </div>), '删除-SKU')
      .then(_=>{
        const loading = this.$loading({
          target: '.app-main',
          lock: true,
        });
        const params = {
          params: {
            skuId
          }
        };
        this.$q.newProduct.deleteSku(params)
          .then(({success}) => {
            if (success) {
              this.$notify.success({
                title: '成功',
                message: '删除SKU成功',
              });
              this.getSpuDetail();
            }
          })
          .finally(() => {
            loading.close();
          });
      })
      .catch(_=> {});
    }
  }
}